import { render, staticRenderFns } from "./newYcygVariation.vue?vue&type=template&id=573bfe28&scoped=true"
import script from "./newYcygVariation.vue?vue&type=script&lang=js"
export * from "./newYcygVariation.vue?vue&type=script&lang=js"
import style0 from "./newYcygVariation.vue?vue&type=style&index=0&id=573bfe28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573bfe28",
  null
  
)

export default component.exports